import React from 'react';
import ProtectedRoute from '../../components/ProtectedRoute/ProtectedRoute';
import InterviewLeavesPage from '../../features/interview/components/InterviewLeavesPage';

const InterviewLeavesPageRoute = () => (
  <ProtectedRoute requiresAuth={true}>
    <InterviewLeavesPage />
  </ProtectedRoute>
);

export default InterviewLeavesPageRoute;
